// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rvi-popover {\n  padding: 14px !important;\n}\n.rvi-popover .el-popover__title {\n    color: #333;\n    font-size: 16px;\n    font-weight: bold;\n    padding-bottom: 10px;\n    margin-bottom: 13px;\n    border-bottom: 1px solid #eeeff3;\n}\n", ""]);
// Exports
module.exports = exports;
